import DatePicker from './src/main'

DatePicker.install = function (Vue) {
    Vue.component(DatePicker.name, DatePicker)
}

export default DatePicker